import digitalData from 'digital-data';
import {
  BIA_MY_ACCOUNT,
  BUTTON_SUBMISSION,
  INTERACTION,
  OVERLAY,
  MY_ACCOUNT_SETTINGS,
  LIST_CREATE_GROUP,
  LIST_EDIT_GROUP,
  LIST_SETTINGS,
  LIST_EMAIL,
  LIST_PRINT,
  LIST_VIEW_MODIFICATION,
  LIST_ADD,
  LIST_REMOVE,
  LIST_PAGINATION_SETTINGS_PREFIX,
  LIST_REARRANGE_PRODUCT,
  LIST_NOTE_SAVED,
  LIST_FUNCTION_SELECT_ALL,
  LIST_FUNCTION_DESELECT_ALL,
  LIST_FUNCTION_COMPARE,
  LIST_FUNCTION_EXPAND_ALL,
  LIST_FUNCTION_COLLAPSE_ALL,
  LIST_MAKE_NOTE
} from '../constants';
import { getState } from '../analytics-state';

export const productList = () => {
  LIFE_CYCLE_EVENT_BUS.on('product-list.remove-product', ({ output }) => {
    const { products } = output;
    const item = products.map((product) => ({
      quantity: product.quantity,
      price: {
        basePrice: product.price,
      },
      productInfo: {
        sku: product.itemId,
        intent: {
          status: product.intentStatus || 'no',
          resolvedIntent: product.resolvedFromIntent || 'no'
        }
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: LIST_VIEW_MODIFICATION
      },
      eventInfo: {
        eventName: LIST_REMOVE
      },
      item
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.increment-quantity', ({ output }) => {
    const { products } = output;
    const item = products.map((product) => ({
      quantity: product.quantity,
      price: {
        basePrice: product.price
      },
      productInfo: {
        sku: product.itemId,
        intent: {
          status: product.intentStatus || 'no',
          resolvedIntent: product.resolvedFromIntent || 'no'
        }
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: LIST_VIEW_MODIFICATION
      },
      eventInfo: {
        eventName: LIST_ADD
      },
      item
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.atc', ({ output }) => {
    const { pageType = null } = getState() || {};
    const { products } = output;
    const items = products.map((product) => ({
      productID: product.itemId,
      index: product?.index,
      intentStatus: product.intentStatus || 'no',
      resolvedFromIntent: product.resolvedFromIntent || 'no'
    }));
    const ddoEvent = {
      category: {
        primaryCategory: 'stash'
      },
      eventInfo: {
        eventName: 'cart add location'
      },
      eventMode: 'stash',
      stash: {
        pageType,
        sharedSection: 'n/a',
        section: 'n/a',
        component: 'n/a',
        target: 'atc',
        items
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.email-list', () => {
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: LIST_EMAIL
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.print-list', () => {
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: LIST_PRINT
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.pagination', ({ output }) => {
    const { page } = output;
    const settings = `${LIST_PAGINATION_SETTINGS_PREFIX}${page}`;
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: BIA_MY_ACCOUNT
      },
      myAccount: { settings }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.post-load-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output || {};
    const ddoEvent = {
      category: {
        primaryCategory: 'error'
      },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type,
          displayType,
          pageSection,
          message,
          code
        }]
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.rearranging-product', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_REARRANGE_PRODUCT
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.expand-all', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_FUNCTION_EXPAND_ALL
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.collapse-all', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_FUNCTION_COLLAPSE_ALL
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // List Create Group Analytics Events
  LIFE_CYCLE_EVENT_BUS.on('product-list.create-group', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_CREATE_GROUP
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.create-group-success', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: 'list details: group: group created'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // Requirement 3: Edit Group Settings
  LIFE_CYCLE_EVENT_BUS.on('product-list.edit-group', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_EDIT_GROUP
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.edit-group-success', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: 'list details: edit group settings overlay: group name edited'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.rearrange-group', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: 'list details: group: group rearranged'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.settings-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_SETTINGS
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.email-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_EMAIL
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.make-note-overlay', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: LIST_MAKE_NOTE
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.note-saved', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_NOTE_SAVED
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.select-all', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_FUNCTION_SELECT_ALL
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.deselect-all', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_FUNCTION_DESELECT_ALL
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('product-list.compare', () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: LIST_FUNCTION_COMPARE
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('intent.edit-name', () => {
    const ddoEvent = {
      category: { primaryCategory: BUTTON_SUBMISSION },
      eventInfo: { eventName: MY_ACCOUNT_SETTINGS },
      myAccount: {
        settings: 'list details: intent: edit name'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on('intent.search', () => {
    const ddoEvent = {
      category: { primaryCategory: BUTTON_SUBMISSION },
      eventInfo: { eventName: MY_ACCOUNT_SETTINGS },
      myAccount: {
        settings: 'list details: intent: search'
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};